<template>
  <div class="flex flex-col w-full gap-2">
    <div class="flex flex-col">
      <span v-if="showTitle" class="text-lg leading-5 text-zinc-800 text-left">
        Expert Tags
      </span>
      <BaseLabel
        forAttr="expertTags"
        text="Add custom tags to your expert program so experts can further personalize and customize their expertise! Custom tags are used to showcase popular features, unique use cases, industry specific expertise, and more. These tags can then be used to filter experts in your booking system to find more relevant experts. Once you save new tags all your active experts will receive an email prompting them to update their profile."
        class="text-sm leading-5 mt-1 text-gray-500 text-left"
      />
    </div>
    <div class="flex flex-col">
      <div class="flex flex-row w-full items-center gap-2">
        <div class="flex flex-col w-full">
          <BaseInput
            id="expertTags"
            v-model="newPopularProduct"
            placeholder="Enter expert tags"
            className="px-3.5 py-2.5 w-full border border-gray-300 rounded-md text-sm font-normal leading-5 whitespace-nowrap"
            @keydown.enter.prevent="addPopularProduct"
          />
        </div>
        <div class="flex flex-col">
          <BaseButton
            type="button"
            text="Add"
            class="max-w-max border border-gray-300 rounded-full px-2.5 py-1"
            @click="addPopularProduct"
          >
            +
          </BaseButton>
        </div>
      </div>
      <div class="flex flex-col" v-if="addPopularProductError">
        <span class="text-xs text-red-500 text-left">
          Tag already present!
        </span>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="flex flex-wrap gap-2 mt-3">
        <div
          v-for="(product, index) in modelValue"
          :key="index"
          class="flex items-center bg-gray-100 rounded-md px-3 py-1.5"
        >
          <span class="text-sm">{{ product }}</span>
          <button
            type="button"
            @click="removeProduct(index)"
            class="ml-2 text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import BaseLabel from "@/components/shared/BaseLabel.vue";
import BaseInput from "@/components/shared/BaseInput.vue";
import BaseButton from "@/components/shared/BaseButton.vue";

export default defineComponent({
  name: "ExpertTagsList",
  components: {
    BaseLabel,
    BaseInput,
    BaseButton,
  },
  props: {
    modelValue: {
      type: Array as () => string[],
      required: true,
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const newPopularProduct = ref("");
    const addPopularProductError = ref(false);

    const addPopularProduct = () => {
      if (newPopularProduct.value) {
        if (
          props.modelValue
            .map((product) => product.toLowerCase())
            .includes(newPopularProduct.value.toLowerCase())
        ) {
          addPopularProductError.value = true;
          setTimeout(() => {
            addPopularProductError.value = false;
          }, 2500);
        } else {
          const updatedList = [...props.modelValue, newPopularProduct.value];
          emit("update:modelValue", updatedList);
          newPopularProduct.value = "";
          addPopularProductError.value = false;
        }
      }
    };

    const removeProduct = (index: number) => {
      const updatedList = [...props.modelValue];
      updatedList.splice(index, 1);
      emit("update:modelValue", updatedList);
    };

    return {
      newPopularProduct,
      addPopularProduct,
      addPopularProductError,
      removeProduct,
    };
  },
});
</script>
